import type { IconSvgObject } from './types';

const TieIcon: IconSvgObject = [
  ["path", { d: "M10 8L7.64689 17.4124C7.5566 17.7736 7.67442 18.155 7.95267 18.4024L11.3356 21.4095C11.7145 21.7462 12.2855 21.7462 12.6644 21.4095L16.0473 18.4024C16.3256 18.155 16.4434 17.7736 16.3531 17.4124L14 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 2L8.70492 3.09836C8.09092 3.30303 7.83013 4.0282 8.17315 4.57704L10 7.5L12 8L14 7.5L15.8268 4.57704C16.1699 4.0282 15.9091 3.30303 15.2951 3.09836L12 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TieIcon;
